var React = require('react');

function Withdraw (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"8","transform":"rotate(-90 8 8)","fill":"#FED0CE","key":0}),React.createElement("path",{"d":"M3.83333 7H12.1667C12.6276 7 13 7.48209 13 8.01426C13 8.54643 12.6273 9 12.1667 9H3.83333C3.37266 9 3 8.57496 3 8.01426C3 7.45357 3.37266 7 3.83333 7Z","fill":"#F46A6A","key":1})]);
}

Withdraw.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Withdraw;

Withdraw.default = Withdraw;
